// extracted by mini-css-extract-plugin
export default {"languages":"language-selector_languages__g5PPQ","language":"language-selector_language__Muvlj","footer":"language-selector_footer__T8C2E","body":"language-selector_body__y4H5o"};